// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-component-wrapper {
  padding: 0 !important;
}
.orders-component-wrapper .orders-component-title {
  height: 85px;
  background-color: #fff;
  align-items: center;
  display: flex;
}
.orders-component-wrapper .vert-title {
  font-size: var(--font-giant);
  font-weight: 600;
  line-height: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Orders/OrdersList/OrdersListStyles.less"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;AAFA;EAIM,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AACN;AARA;EAWM,4BAAA;EACA,gBAAA;EACA,iBAAA;AAAN","sourcesContent":[".orders-component-wrapper {\n    padding: 0 !important;\n\n    .orders-component-title {\n      height: 85px;\n      background-color: #fff;\n      align-items: center;\n      display: flex;\n    }\n\n    .vert-title {\n      font-size: var(--font-giant);\n      font-weight: 600;\n      line-height: 28px;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
